export function distinct<T>(values: T[]): T[] {
  return Array.from(new Set(values))
}

export function firstOrUndefined<T>(values: T[]): T | undefined {
  return values.find((x) => x !== undefined)
}
